import { BuyMusicChannelDto } from '../../../dto/buymusicchannel/buymusicchanneldto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface BuyMusicChannelRequest extends APIRequest
{
    getBuyMusicChannelRequest(): BuyMusicChannelDto;
}

export class BuyMusicChannelRequestImpl extends APIRequestDtoImpl implements BuyMusicChannelRequest
{
    constructor(private getBuyMusicChannelData: BuyMusicChannelDto)
    {
        super();
    }

    getBuyMusicChannelRequest(): BuyMusicChannelDto
    {
        return this.getBuyMusicChannelData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/buymusicchannel/buymusicchannelrequest.tsx